import { render, staticRenderFns } from "./StudyEditor.vue?vue&type=template&id=74a73fa9"
import script from "./StudyEditor.vue?vue&type=script&lang=js"
export * from "./StudyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports